var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"ripple":"","exact":"","to":_vm.parentURL}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("mdi-chevron-left")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }